module.exports = __webpack_public_path__ + "img/22_32.b0be3e86.png";